<!-- Amount: "12 345 zł" (blurred in privacy mode). -->
<script lang="ts">
  import { fmtNum } from "../lib/format";
  let { v, d = 0, ccy = "zł" }: { v: number | null | undefined; d?: number; ccy?: string } = $props();
</script>

<span class="money">{fmtNum(v, d)}&nbsp;{ccy}</span>
